import { processPublications } from "@/utils/publications";
import { Publication } from "@/store/publications";

function state() {
    const result: Publication[] = [
        // Books
        {
            author: "高跃，戴琼海",
            title: "超图计算",
            journal: "科学出版社",
            volume: "ISBN: 978-7-03-081633-7",
            year: "2025",
            tag: { content: "BOOK", color: "primary" },
        },
        {
            author: "Qionghai Dai, Yue Gao",
            title: "Hypergraph Computation",
            journal: "Springer",
            volume: "ISBN: 978-981-99-0184-5",
            year: "2023",
            href: "https://link.springer.com/book/10.1007/978-981-99-0185-2",
            tag: { content: "BOOK", color: "primary" },
        },
        {
            author: "Yue Gao, Qionghai Dai",
            title: "View-based 3-D Object Retrieval",
            journal: "Elsevier",
            volume: "ISBN: 978-0-12-802419-5",
            year: "2014",
            href: "https://www.sciencedirect.com/book/9780128024195/view-based-3-d-object-retrieval",
            tag: { content: "BOOK", color: "primary" },
        },
        {
            author: "Rongrong Ji, Yue Gao, Ling-Yu Duan, Hongxun Yao, Qionghai Dai",
            title: "Learning-Based Local Visual Representation and Indexing",
            journal: "Elsevier",
            volume: "ISBN: 978-0-12-802409-6",
            year: "2015",
            href: "https://www.sciencedirect.com/book/9780128024096/learning-based-local-visual-representation-and-indexing",
            tag: { content: "BOOK", color: "primary" },
        },

        // Representative publications
        {
            author: "Yifan Feng, Hao Hu, Shihui Ying, Xingliang Hou, Shiquan Liu, Mingyuan Yang, Junchang Li, Shaoyi Du, Nanning Zheng, Han Hu, Yue Gao",
            title: "Hyper-RAG: Combating LLM Hallucinations Using Hypergraph-Driven Retrieval-Augmented Generation",
            journal: "Nature Communications",
            year: "2026",
            href: "https://www.nature.com/articles/s41467-026-71411-1",
            tag: { content: "Nature Communications", color: "primary" },
        },
        {
            author: "Yue Gao, Zizhao Zhang, Haojie Lin, Xibin Zhao, Shaoyi Du, Changqing Zou",
            title: "Hypergraph Learning: Methods and Practices",
            journal: "IEEE Transactions on Pattern Analysis and Machine Intelligence",
            year: "2022",
            href: "https://ieeexplore.ieee.org/abstract/document/9264674/",
        },
        {
            author: "Yifan Feng, Jiangang Huang, Shaoyi Du, Shihui Ying, Jun-Hai Yong, Yipeng Li, Guiguang Ding, Rongrong Ji, Yue Gao",
            title: "Hyper-YOLO: When Visual Object Detection Meets Hypergraph Computation",
            journal: "IEEE Transactions on Pattern Analysis and Machine Intelligence",
            volume: "47(4)",
            page: "2388-2401",
            year: "2025",
            href: "https://doi.org/10.1109/TPAMI.2024.3524377",
            code: "https://github.com/iMoonLab/Hyper-YOLO",
        },
        {
            author: "Yue Gao, Yifan Feng, Shiquan Liu, Xiangmin Han, Shaoyi Du, Zongze Wu, Han Hu",
            title: "Hypergraph Foundation Model",
            journal: "IEEE Transactions on Pattern Analysis and Machine Intelligence",
            volume: "48(4)",
            page: "4063-4080",
            year: "2026",
            href: "https://doi.org/10.1109/TPAMI.2025.3647504",
        },
        {
            author: "Yue Gao, Shuyi Ji, Xiangmin Han, Qionghai Dai",
            title: "Hypergraph Computation",
            journal: "Engineering",
            abbreviation: "Engineering",
            year: "2024",
            href: "https://www.sciencedirect.com/science/article/pii/S2095809924002510",
        },
        {
            author: "Yifan Feng, Haoxuan You, Zizhao Zhang, Rongrong Ji, Yue Gao",
            title: "Hypergraph Neural Networks",
            journal: "Proceedings of the AAAI Conference on Artificial Intelligence",
            volume: "33(01)",
            page: "3558-3565",
            year: "2019",
            href: "https://ojs.aaai.org/index.php/AAAI/article/view/4235",
        },
        {
            author: "Yue Gao, Yifan Feng, Shuyi Ji, Rongrong Ji",
            title: "HGNN+: General Hypergraph Neural Networks",
            journal: "IEEE Transactions on Pattern Analysis and Machine Intelligence",
            volume: "45(3)",
            page: "3181-3199",
            year: "2023",
            href: "https://ieeexplore.ieee.org/abstract/document/9795251",
        },
        {
            author: "Yifan Zhang, Shaoyi Du, Yifan Feng, Shihui Ying, Yue Gao",
            title: "Reinterpreting Hypergraph Kernels: Insights Through Homomorphism Analysis",
            journal: "IEEE Transactions on Pattern Analysis and Machine Intelligence",
            volume: "48(1)",
            page: "466-481",
            year: "2026",
            href: "https://doi.org/10.1109/TPAMI.2025.3608902",
        },
    ];

    processPublications(result);
    return result;
}

export default state();
